var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiw3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1605 88.4709V88.4709C45.1605 87.2523 44.1726 86.2644 42.9541 86.2644H42.1175C40.6871 86.2644 39.5276 87.424 39.5276 88.8544V89.1776C39.5276 90.608 40.6871 91.7676 42.1175 91.7676H42.4739C43.8573 91.7676 44.9788 92.8891 44.9788 94.2725V94.2725C44.9788 95.656 43.8573 96.7775 42.4738 96.7775H41.5783C40.4457 96.7775 39.5276 95.8594 39.5276 94.7268V94.7268M42.3051 97.1669V99.4252M42.3051 85.7972V83.7724",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8778 77.512V77.512C72.8778 76.2935 71.8899 75.3056 70.6713 75.3056H69.8347C68.4044 75.3056 67.2448 76.4652 67.2448 77.8955V78.2188C67.2448 79.6492 68.4044 80.8087 69.8347 80.8087H70.1911C71.5746 80.8087 72.6961 81.9302 72.6961 83.3137V83.3137C72.6961 84.6972 71.5746 85.8187 70.1911 85.8187H69.2955C68.1629 85.8187 67.2448 84.9005 67.2448 83.768V83.768M70.0224 86.208V88.4664M70.0224 74.8384V72.8136",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.609 66.5077V66.5077C100.609 65.2891 99.6208 64.3013 98.4023 64.3013H97.5657C96.1353 64.3013 94.9757 65.4608 94.9757 66.8912V67.2145C94.9757 68.6449 96.1353 69.8044 97.5657 69.8044H97.922C99.3055 69.8044 100.427 70.9259 100.427 72.3094V72.3094C100.427 73.6928 99.3055 74.8144 97.922 74.8144H97.0264C95.8939 74.8144 94.9757 73.8962 94.9757 72.7637V72.7637M97.7533 75.2037V77.4621M97.7533 63.834V61.8093",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3982 48.3078L98.1681 37.3534C99.1837 36.3203 99.1545 34.6551 98.1032 33.6583L95.8413 31.5135C95.4311 31.1245 95.6814 30.4335 96.2456 30.3975L107.412 29.6854C108.95 29.5872 110.233 30.8466 110.164 32.3867L109.687 42.9637C109.661 43.527 108.978 43.7909 108.581 43.3909L106.232 41.0268C105.23 40.0192 103.604 40.0061 102.587 40.9974L88.7315 54.4977C87.7342 55.4694 86.1471 55.4787 85.1385 54.5188L76.5603 46.3547C76.3104 46.1169 75.918 46.1167 75.668 46.3543L52.4344 68.4262C51.4624 69.3495 49.9466 69.3785 48.94 68.4931L43.0851 63.343C42.8376 63.1253 42.4662 63.1282 42.2222 63.3497L34.8035 70.0836C33.7662 71.0251 32.1679 70.9698 31.1982 69.9588C30.2179 68.9368 30.2417 67.3164 31.2516 66.3236L40.845 56.8928C41.8488 55.9061 43.4568 55.9016 44.466 56.8828L48.9085 61.2018C49.9152 62.1806 51.5186 62.1788 52.5233 61.1978L74.3023 39.9313C75.3095 38.9477 76.918 38.9489 77.9238 39.9339L86.4835 48.3165C86.7386 48.5664 87.1479 48.5625 87.3982 48.3078Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.7922,
    cy: 69.6357,
    r: 12.5017,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8617,
    cy: 80.64,
    r: 12.5017,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.3509,
    cy: 91.6443,
    r: 12.5017,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2577,
    y: 104.146,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9467,
    y: 93.1418,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6357,
    y: 93.4257,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6357,
    y: 87.7664,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6357,
    y: 82.107,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9467,
    y: 98.8011,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6357,
    y: 99.0851,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9467,
    y: 104.461,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6357,
    y: 104.745,
    width: 22.2291,
    height: 5.65938,
    rx: 2.82969,
    stroke: "#008CB7",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiw3);
export default __webpack_public_path__ + "static/media/hiw-3.e03487c6bd7f425f37e561dc34404af9.svg";
export { ForwardRef as ReactComponent };